import React from 'react';
import _ from 'underscore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { getMenuItemStyles } from '../styles/menu-item-styles';
import { abbreviateDynamicItemName } from '../helpers/node-helper';

const DynamicItemIcon = ({
  classes,
  icon,
  iconStatusClassName,
  node,
  isExpanded,
  permissions,
}) => {
  const isNavRefresh = isNavigationRefreshOn(permissions);
  if (isExpanded) {
    return (
      <div className={classNames(classes.dynamicIconContainer, isNavRefresh ? '' : classes.whiteText)}>
        <Glyphicon
          id={`${icon}-icon`}
          className={iconStatusClassName}
          glyph={icon}
        />
      </div>
    );
  }
  return (
    <div className={classes.dynamicItemIconContainer}>
      <div className={node.isSelected ? classes.selectedCollapsedDynamicItemIcon : classes.collapsedDynamicItemIcon}>
        {abbreviateDynamicItemName(node.Name)}
      </div>
    </div>
  );
};

DynamicItemIcon.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getMenuItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  icon: PropTypes.string,
  iconStatusClassName: PropTypes.string,
  isExpanded: PropTypes.bool.isRequired,
  node: PropTypes.shape({
    Name: PropTypes.string,
    isSelected: PropTypes.bool,
  }).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

DynamicItemIcon.defaultProps = {
  icon: 'collapsed',
  iconStatusClassName: 'DynamicIcon',
};

const Wrapped = withPermissions(DynamicItemIcon);

export { Wrapped as DynamicItemIcon };
